import {Component, OnInit} from '@angular/core';
import {DigitalSignCheckItem, DigitalSignCheckList} from '../../models/digital-sign-interfaces';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {DigitalSignService} from '../../services/digital-sign.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {LoaderService} from '@shared/service/loader.service';
import {DigitalSignUtilities} from '../../utilities/digital-sign-utilities.model';
import {OrdersDeclinedDigitalSignService} from '../../../delivery/services/orders-declined-digital-sign.service';
import {InnerMessage, InnerMessagesService} from '@shared/service/inner-messages.service';
import {ContractDeclinedDigitalSignatureService} from '@cc-sp-operator/services/contract-declined-digital-signature.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-check-list',
	templateUrl: './digital-sign-check-list.component.html',
	styleUrls: ['./digital-sign-check-list.component.scss']
})
export class DigitalSignCheckListComponent implements OnInit {

	orderType = DigitalSignUtilities.ORDERS_TYPE;
	contractCloseType = DigitalSignUtilities.CONTRACT_CLOSE_TYPE;

	digitalsignCheckList: DigitalSignCheckList;
	type: string;
	resource_id: string;
	ds_dossier_id: string;
	params_id: string;
	privacyAccepted = -1;
	subRoute: Subscription;
	translateContext: TranslateContext = TranslateContext.DIGITAL_SIGN;

	constructor(public router: Router,
				public route: ActivatedRoute,
				public loaderService: LoaderService,
				public digitalSignService: DigitalSignService,
				public innerMessageService: InnerMessagesService,
				public ordersDeclinedDSService: OrdersDeclinedDigitalSignService,
				public contractDeclinedDigitalSignatureService: ContractDeclinedDigitalSignatureService) {

	}

	ngOnInit() {
		this.subRoute = this.route.params.subscribe(
			params => {
				this.type = params['type'];
				this.resource_id = params['resource_id'];
				this.ds_dossier_id = params['ds_dossier_id'];
				this.params_id = params['params_id'];

				switch (this.type) {
					case this.orderType:
						this.digitalsignCheckList = new OrderDigitalSignCheckListModel();
						break;
					case this.contractCloseType:
						this.digitalsignCheckList = new ContractDigitalSignCheckListModel();
						break;
				}

				this.digitalSignService.getDossier(this.resource_id, this.type, this.ds_dossier_id).subscribe(
					resp => {
						if (!Utilities.isVoid(resp) && this.ds_dossier_id === resp.dossier_id) {
							this.manageStatus(resp.state);
						} else {
							setTimeout(() => {
								this.innerMessageService.pushInnerMessage(new InnerMessage(InnerMessage.DIGITAL_SIGN_GENERIC_ERROR, InnerMessage.TYPE_WARNING, null, true));
							}, 1000);
							this.router.navigate(DigitalSignUtilities.getGoBackRoute(this.type, this.resource_id));
						}
					}, error => {
						setTimeout(() => {
							this.innerMessageService.pushInnerMessage(new InnerMessage(InnerMessage.DIGITAL_SIGN_GENERIC_ERROR, InnerMessage.TYPE_WARNING, null, true));
						}, 1000);
						this.router.navigate(DigitalSignUtilities.getGoBackRoute(this.type, this.resource_id));
					});
			});
	}

	issueWithDS() {
		if (this.privacyAccepted === 0) {
			if (this.type === DigitalSignUtilities.ORDERS_TYPE) {
				this.ordersDeclinedDSService.addOrderDeclinedDs(+this.resource_id);
			} else if (this.type === this.contractCloseType) {
				this.contractDeclinedDigitalSignatureService.addContractDeclinedDs(this.resource_id);
			}
			this.goBack(null);
		}
	}

	goBack(event: any) {
		//TODO add abort dossier
		this.loaderService.display(true);
		this.digitalSignService.abortDossier(this.resource_id, this.type, this.ds_dossier_id).subscribe(
			res => {
				if (res.status === 204 || res.status === 200) { // TODO: check status==2000
					if (!Utilities.isVoid(event)) {
						setTimeout(() => {
							this.innerMessageService.pushInnerMessage(new InnerMessage(InnerMessage.DIGITAL_SIGN_ABORT_OK, InnerMessage.TYPE_SUCCESS, null, true));
						}, 1000);
					}
					this.router.navigate(DigitalSignUtilities.getGoBackRoute(this.type, this.resource_id));
				} else {
					this.loaderService.display(false);
				}
				//TODO innerMessage
			}, error => {
				this.loaderService.display(false);
			});
	}

	manageStatus(state: number): void {
		if (state === DigitalSignUtilities.SENT) {
			this.loaderService.display(false);
			return;
		}
		if (state === DigitalSignUtilities.SIGNATURE_PROCESS_COMPLETED || state === DigitalSignUtilities.ABORTED
			|| state === DigitalSignUtilities.ERROR) {
			setTimeout(() => {
				this.innerMessageService.pushInnerMessage(new InnerMessage(InnerMessage.DIGITAL_SIGN_STATUS_ERROR, InnerMessage.TYPE_WARNING, null, true));
			}, 1000);
			this.router.navigate(DigitalSignUtilities.getGoBackRoute(this.type, this.resource_id));
			return;
		}
		this.next();
	}

	next(event?: any) {
		this.loaderService.display(true);
		this.router.navigate(['digital-sign/procedure', this.type, this.resource_id, this.ds_dossier_id, this.params_id, 'checked']);
	}

	privacyRequestChange(event: any) {
		this.privacyAccepted = event.value;
		if (!this.privacyAccepted && !Utilities.isVoid(this.digitalsignCheckList) && !Utilities.isVoid(this.digitalsignCheckList.checklist)) {
			this.digitalsignCheckList.checklist.forEach(
				item => {
					item.value = false;
				});
		}
	}
}

export class OrderDigitalSignCheckListModel extends DigitalSignCheckList {
	reference_type: number;
	checklist: DigitalSignCheckItem[];

	constructor() {
		super();
		this.reference_type = 1;
		this.checklist = [];
		this.checklist.push(new DigitalSignCheckItemModel(true, 1));
		this.checklist.push(new DigitalSignCheckItemModel(false, 2));
		this.checklist.push(new DigitalSignCheckItemModel(true, 3));
	}
}

export class ContractDigitalSignCheckListModel extends DigitalSignCheckList {
	reference_type: number;
	checklist: DigitalSignCheckItem[];

	constructor() {
		super();
		this.reference_type = 1;
		this.checklist = [];
		this.checklist.push(new DigitalSignCheckItemModel(false, 2));
		this.checklist.push(new DigitalSignCheckItemModel(true, 3));
	}
}

export class DigitalSignCheckItemModel extends DigitalSignCheckItem {
	required: boolean;
	title: number;
	description: number;
	value: boolean;
	translateContext: TranslateContext = TranslateContext.DIGITAL_SIGN;

	constructor(required: boolean, reference_id: number) {
		super();
		this.value = false;
		this.required = required;
		this.title = reference_id;
		this.description = reference_id;
	}
}
